'use client';
import Link from 'next/link';
import logo from '../assets/images/logo.png';
import Image from 'next/image';
import { useSession } from 'next-auth/react';

function Navigation() {
  const { data: session } = useSession();

  return (
    <header>
      <nav className="container-fluid px-2">
        <div className="navbar bg-base-100">
          <div className="navbar-start">
            <Link className="flex items-center normal-case text-xl font-bold text-info tracking-wide" href="/">
              <Image src={logo} alt="ScalePracticer" width={24} height={24} />
              ScalePracticer
            </Link>
          </div>
          {!session && (
            <p className="navbar-center pl-2 lg:visible md:invisible sm:invisible">
              Learn guitar scales and track your progress
            </p>
          )}
          <div className="navbar-end">
            <ul className="menu menu-horizontal p-0">
              <li>
                <Link className="btn btn-soft m-1" href="/about">
                  About
                </Link>
              </li>
              {session && (
                <li>
                  <Link href="/profile" className="btn btn-secondary m-1">
                    Profile
                  </Link>
                </li>
              )}
              {!session && (
                <li>
                  <Link href="/signin" className="btn btn-secondary text-neutral m-1">
                    Sign In
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
export default Navigation;
